import { isEqual } from "lodash";

/** Internal helper keys from flowsheet value extractors; excluded from amend diff comparison. */
const LABOR_OBSERVATION_DIFF_DISPLAY_HELPER_FIELDS = ["hasAnswers", "hasNotes"] as const;

/**
 * Returns whether two plain display-value records differ for amend version diff rendering.
 * Ignores internal helper keys used by flowsheet value extractors.
 */
export function laborObservationDisplayValuesDiffer(
  currentValues: Record<string, unknown>,
  previousValues: Record<string, unknown>,
  options: { structuredExcludeFields?: string[] } = {},
): boolean {
  const excludeFields = new Set([
    ...LABOR_OBSERVATION_DIFF_DISPLAY_HELPER_FIELDS,
    ...(options.structuredExcludeFields ?? []),
  ]);

  const fieldNames = new Set([...Object.keys(currentValues), ...Object.keys(previousValues)]);

  for (const fieldName of fieldNames) {
    if (excludeFields.has(fieldName)) {
      continue;
    }
    if (!isEqual(currentValues[fieldName], previousValues[fieldName])) {
      return true;
    }
  }

  // No comparable display fields — do not treat as a user-visible amend change.
  return false;
}
